import { z } from 'zod';
import { PaginationQuery } from '../../utils/listQuery';
import { listResponse, ListResponse } from '../../utils/listResponse';
import { RuleExecutionLog } from '../models/ruleExecutionLog';
import { ruleExecutionLogSchema } from '../models/ruleExecutionLog.schema';
import { rulesExecutionLogsQuerySchema } from './list.schema';

/**
 * @noSchema
 */
export type RulesExecutionLogsResponse = ListResponse<RuleExecutionLog>;

export type RulesExecutionLogsQuery = PaginationQuery & {
  createdAtAfter?: string;
  createdAtBefore?: string;
  rule?: Array<number>;
  annotation?: Array<number>;
  queue?: Array<number>;
  requestId?: string;
  executionResult?: Array<string>;
  triggerEvent?: Array<string>;
  triggerMatch?: boolean;
  search?: string;
};

export const list = (query: RulesExecutionLogsQuery = {}) => {
  return {
    endpoint: `/rules_execution_logs`,
    method: 'GET',
    responseSchema: listResponse(ruleExecutionLogSchema),
    query: { ...query, includeTotal: true },
    querySchema: rulesExecutionLogsQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
